import requestFunctions from "../../functions/requestFunctions";


export const state = {
  CHANNELS_ITEM: {},
  CHANNELS_LIST: [],
  CHANNELS_TABLE_DATA: [],
  CHANNELS_LIST_DATA: [],
  CHANNELS_TOTAL_ROWS: 0
}

export const getters = {
  GET_CHANNELS_ITEM: (state) => {
    return state.CHANNELS_ITEM;
  },
  GET_CHANNELS_LIST: (state) => {
    return state.CHANNELS_LIST;
  },
  GET_CHANNELS_TABLE_DATA: (state) => {
    return state.CHANNELS_TABLE_DATA;
  },
  GET_CHANNELS_LIST_DATA: (state) => {
    return state.CHANNELS_LIST_DATA;
  },
  GET_CHANNELS_TOTAL_ROWS: (state) => {
    return state.CHANNELS_TOTAL_ROWS;
  }
}

export const mutations = {

  UPDATE_CHANNELS_ITEM(state, item) {
    state.CHANNELS_ITEM = item;
  },

  UPDATE_CHANNELS_LIST(state, list) {
    
    state.CHANNELS_LIST = list.data;

    state.CHANNELS_TOTAL_ROWS = list.total;
    list = list.data;
    
    state.CHANNELS_TABLE_DATA = [];
    state.CHANNELS_LIST_DATA = [];

    list.forEach(el => {

      let status = '';

      if(el.status === 'active'){
        status = 'Активный'
      }
      if(el.status === 'wait'){
        status = 'Ожидает активации'
      }
      if(el.status === 'disabled'){
        status = 'Отключен'
      }

      state.CHANNELS_TABLE_DATA.push({
        'uuid'   : el.uuid,
        'name'   : el.name,
        'status' : status,
        'code'   : el.code,
        'action_name' : el.action_name,        
        'fl_onlyone'  : el.fl_onlyone,
        'fl_default'  : el.fl_default
      });
      
      state.CHANNELS_LIST_DATA.push({
        id: el.id,
        uuid: el.uuid,
        name: el.name,
        code: el.code,
        fl_onlyone: el.fl_onlyone,
        fl_default: el.fl_default
      });
      
    });    
  },
}

export const actions = {

  async FETCH_CHANNELS_ITEM({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/channels/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_CHANNELS_ITEM', response.data);
      return response.data;
    }
  },

  async FETCH_CHANNELS_LIST({ commit }, payload= {}) {

    let query_url = 'https://api.client.za-bota.com/v1/channels';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_CHANNELS_LIST', response.data);
      return response.data;
    }
  },

  async FETCH_CHANNELS_CREATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/channels';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_CHANNELS_UPDATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/channels/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_CHANNELS_DELETE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/channels/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },
}